import Lottie from 'react-lottie';
import animationData from '@assets/lottie-files/404-heart';

const LottieFile = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="mb-8 relative">
      <div className="absolute w-full h-full z-50"></div>
      <Lottie
        id={'tenthLottie'}
        options={defaultOptions}
        height={400}
        width={580}
        speed={1}
      />
    </div>
  );
};

export default LottieFile;
